//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex';

export default {
  name: "SearchFiltersItem",
  props: ["filter", "groupID"],
  data() {
    return { };
  },
  computed: {
    display() {
      return this.filter.value + " (" + this.filter.count + ")";
    },
    selected: {
      get() {
        return this.filter.selected;
      },
      set(value) {
        const data = {
          groupID: this.groupID,
          id: this.filter.id,
          value
        };
        this.setFilterItem(data);
      }
    }
  },
  methods: {
    ...mapMutations(['setFilterItem'])
  },
  created() {
    if (this.$route.query.c) {
      let filters = this.$route.query.c.split(',')
      if (filters.includes(this.filter.id)) {
        this.selected = true;
      }
    }
  }
};
